import { NgModule } from '@angular/core';
import { HtmlPipe, ReplacePipe, SafePipe } from './safe.pipe';

@NgModule({
  declarations: [
    SafePipe,
    HtmlPipe,
    ReplacePipe
  ],
  imports: [],
  exports: [
    SafePipe,
    HtmlPipe,
    ReplacePipe
  ]
})
export class PipesModule { }
